import { render } from "./checkboxInput.vue?vue&type=template&id=61192d35&scoped=true"
import script from "./checkboxInput.vue?vue&type=script&lang=js"
export * from "./checkboxInput.vue?vue&type=script&lang=js"

import "./checkboxInput.vue?vue&type=style&index=0&id=61192d35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61192d35"]])

export default __exports__